import React from 'react'
// components
import MainLayoutAPI from 'containers/MainLayout/layers/API/index'
import MainLayout from 'layouts/MainLayout'

// types
export interface IMainLayoutProps {
  CTA?: React.ReactNode
  center?: React.ReactNode
  label?: React.ReactNode
  children?: React.ReactNode
  isLoading?: boolean
  disableScroll?: boolean
}

const MainLayoutContainer: React.FC<IMainLayoutProps> = (props) => (
  <MainLayoutAPI>
    <MainLayout {...props} />
  </MainLayoutAPI>
)

export default MainLayoutContainer
